import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Sidebar.css';
import addProductIcon      from '../Assets/Product_Cart.svg';
import newArrivalsIcon     from '../Assets/new-arrival.png';
import bannerIcon          from '../Assets/banner_icon.png';
import faqIcon             from '../Assets/faq_icon.png';
import dashboardIcon       from '../Assets/dashboard_icon.png';
import categoryIcon        from '../Assets/category.png';
import designPatternIcon   from '../Assets/designpatterns.png';
import videosIcon          from '../Assets/videos.png';
import varietyOfAccessoriesIcon from '../Assets/variety.png';
import topSellersIcon      from '../Assets/topsellers.png';
import homepageIcon        from '../Assets/homepage.png';
import ordersIcon          from '../Assets/orders.png';
import usersIcon           from '../Assets/users.png';
import ideasIcon           from '../Assets/ideas.png';
import featureIcon         from '../Assets/new-features.png';
import promoIcon           from '../Assets/promo.png';
import ratingIcon          from '../Assets/rating.png';
import stockIcon           from '../Assets/stock.svg';

// Role-based visibility helpers
const role = () => sessionStorage.getItem("adminRole") || "";
const can  = (...roles) => roles.includes(role());
const isAdmin       = () => can("admin");
const isAdminOrStaff = () => can("admin", "admin-staff");
const isAllStaff    = () => can("admin", "admin-staff", "staff");
const isStockAccess = () => can("admin", "admin-staff", "stock-staff");

const Sidebar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();
  const homepageActive = location.pathname.startsWith('/homepage');
  const adminName = sessionStorage.getItem("adminName") || "Admin";

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/admin/login";
  };

  const navCls = ({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`;
  const dropCls = ({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`;

  const ArrowIcon = ({ isOpen }) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      width="18" height="18" className={`arrow-icon ${isOpen ? 'open' : ''}`}>
      <path d="M6 15L12 9L18 15" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  return (
    <div className="sidebar">
      <div className="sidebar-user-top">
        <div className="sidebar-user-avatar">{adminName.charAt(0).toUpperCase()}</div>
        <div className="sidebar-user-info">
          <span className="sidebar-user-name">{adminName}</span>
          <span className="sidebar-user-role">{role() || "—"}</span>
        </div>
      </div>

      <div className="sidebar-scroll">

        {/* Dashboard — all except stock-staff */}
        {isAllStaff() && (
          <NavLink to="/dashboard" className={navCls}>
            <img src={dashboardIcon} alt="Dashboard" />
            <span>Dashboard</span>
          </NavLink>
        )}

        {/* Products — all except stock-staff */}
        {isAllStaff() && (
          <NavLink to="/listproduct" className={navCls}>
            <img src={addProductIcon} alt="Products" />
            <span>Products</span>
          </NavLink>
        )}

        {/* Orders — all except stock-staff */}
        {isAllStaff() && (
          <NavLink to="/orders" className={navCls}>
            <img src={ordersIcon} alt="Orders" />
            <span>Orders</span>
          </NavLink>
        )}

        {/* Customers — admin + admin-staff only */}
        {isAdminOrStaff() && (
          <NavLink to="/customers" className={navCls}>
            <img src={usersIcon} alt="Customers" />
            <span>Customers</span>
          </NavLink>
        )}

        {/* Stock — admin, admin-staff, stock-staff */}
        {isStockAccess() && (
          <NavLink to="/stock" className={navCls}>
            <img src={stockIcon} alt="Stock" />
            <span>Stock</span>
          </NavLink>
        )}

        {/* Excel Upload — admin, admin-staff, stock-staff */}
        {isStockAccess() && (
          <NavLink to="/excel-upload" className={navCls}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 0, flexShrink: 0 }}>
              <rect x="3" y="3" width="18" height="18" rx="3" fill="#dcfce7" stroke="#16a34a" strokeWidth="1.8"/>
              <path d="M8 8h2v8H8zM11 8h5v3h-5zM11 13h5v3h-5z" fill="#16a34a"/>
            </svg>
            <span>Excel Upload</span>
          </NavLink>
        )}

        {/* User Management — admin only */}
        {isAdmin() && (
          <NavLink to="/user-management" className={navCls}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 0, flexShrink: 0 }}>
              <circle cx="9" cy="7" r="4" fill="#e9d5ff" stroke="#7c3aed" strokeWidth="1.8"/>
              <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"
                stroke="#7c3aed" strokeWidth="1.8" strokeLinecap="round"/>
              <path d="M16 11h6M19 8v6" stroke="#7c3aed" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
            <span>Users</span>
          </NavLink>
        )}

        {/* GST Report — admin + admin-staff */}
        {isAdminOrStaff() && (
          <NavLink to="/gst-report" className={navCls}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 0, flexShrink: 0 }}>
              <rect x="4" y="3" width="16" height="18" rx="2" fill="#fef3c7" stroke="#d97706" strokeWidth="1.8"/>
              <path d="M8 8h8M8 12h8M8 16h5" stroke="#d97706" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
            <span>GST Report</span>
          </NavLink>
        )}

        {/* FAQ — admin + admin-staff */}
        {isAdminOrStaff() && (
          <NavLink to="/frequently-asked-questions" className={navCls}>
            <img src={faqIcon} alt="FAQ" />
            <span>FAQ</span>
          </NavLink>
        )}

        {/* Promo — admin + admin-staff */}
        {isAdminOrStaff() && (
          <NavLink to="/promo-codes" className={navCls}>
            <img src={promoIcon} alt="Promocode" />
            <span>Promocode</span>
          </NavLink>
        )}

        {/* Our Ideas — admin + admin-staff */}
        {isAdminOrStaff() && (
          <NavLink to="/explore-our-ideas" className={navCls}>
            <img src={ideasIcon} alt="Our Ideas" />
            <span>Our Ideas</span>
          </NavLink>
        )}

        {/* HomePage dropdown — admin + admin-staff */}
        {isAdminOrStaff() && (
          <>
            <div
              className={`sidebar-item sidebar-parent ${homepageActive ? 'active' : ''}`}
              onClick={() => toggleDropdown('homepage')}
            >
              <img className='icon-img' src={homepageIcon} alt="Homepage" />
              <span>HomePage</span>
              <ArrowIcon isOpen={openDropdown === 'homepage' || homepageActive} />
            </div>

            {(openDropdown === 'homepage' || homepageActive) && (
              <div className="dropdown-content">
                <NavLink to="/homepage/landingbanners" className={dropCls}>
                  <img className='icon-img' src={bannerIcon} alt="banners" />
                  <p className='dropdown-text'>Landing Banners</p>
                </NavLink>
                <NavLink to="/homepage/browsebycategory" className={dropCls}>
                  <img className='icon-img' src={categoryIcon} alt="category" />
                  <p className='dropdown-text'>Category</p>
                </NavLink>
                <NavLink to="/homepage/newarrivals" className={dropCls}>
                  <img className='icon-img' src={newArrivalsIcon} alt="new arrivals" />
                  <p className='dropdown-text'>New Arrivals</p>
                </NavLink>
                <NavLink to="/homepage/varietyofaccessories" className={dropCls}>
                  <img className='icon-img' src={varietyOfAccessoriesIcon} alt="accessories" />
                  <p className='dropdown-text'>Variety of Accessories</p>
                </NavLink>
                <NavLink to="/homepage/topsellers-retrocollections" className={dropCls}>
                  <img className='icon-img' src={topSellersIcon} alt="bestsellers" />
                  <p className='dropdown-text'>Top Sellers/Retro</p>
                </NavLink>
                <NavLink to="/homepage/shopbydesignpatterns" className={dropCls}>
                  <img className='icon-img' src={designPatternIcon} alt="design-patterns" />
                  <p className='dropdown-text'>Design Patterns</p>
                </NavLink>
                <NavLink to="/homepage/browsebyvideos" className={dropCls}>
                  <img className='icon-img' src={videosIcon} alt="videos" />
                  <p className='dropdown-text'>Videos</p>
                </NavLink>
                <NavLink to="/homepage/featured-in" className={dropCls}>
                  <img className='icon-img' src={featureIcon} alt="featured" />
                  <p className='dropdown-text'>Featured In</p>
                </NavLink>
                <NavLink to="/homepage/reviews" className={dropCls}>
                  <img className='icon-img' src={ratingIcon} alt="reviews" />
                  <p className='dropdown-text'>Reviews</p>
                </NavLink>
              </div>
            )}
          </>
        )}

        {/* Settings — admin only */}
        {isAdmin() && (
          <NavLink to="/settings" className={navCls}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 0, flexShrink: 0 }}>
              <circle cx="12" cy="12" r="3" stroke="#7c3aed" strokeWidth="1.8"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
                stroke="#7c3aed" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Settings</span>
          </NavLink>
        )}

        {/* Audit Log — admin only */}
        {isAdmin() && (
          <NavLink to="/audit-log" className={navCls}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 0, flexShrink: 0 }}>
              <path d="M9 2h6l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#ede9fe" stroke="#7c3aed" strokeWidth="1.6"/>
              <path d="M9 12h6M9 16h6M9 8h2" stroke="#7c3aed" strokeWidth="1.6" strokeLinecap="round"/>
            </svg>
            <span>Audit Log</span>
          </NavLink>
        )}
      </div>

      <div className="sidebar-footer">
        <button className="sidebar-logout-btn" onClick={handleLogout}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 17l5-5-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
